import React, { Suspense } from 'react';

import { AddSavedCardModalProps } from './types';

const Modal = React.lazy(() => import('./AddSavedCardMotoModal'));

export default function Wrapper(props: AddSavedCardModalProps) {
  return (
    <Suspense fallback={<></>}>
      <Modal {...props} />
    </Suspense>
  );
}
